type CopySuccessFn = (copied: string) => void;
type CopyFailFn = (attempted: string) => void;

function copyToClipboardFallback(text = '', onSuccess?: CopySuccessFn): void {
    const fakeInput = document.createElement('input');

    document.body.appendChild(fakeInput);

    fakeInput.setAttribute('readonly', 'true');
    fakeInput.setAttribute('value', text);
    fakeInput.select();

    // Added `navigator` function below because execCommand is deprecated.
    // It is still compatible for now though:
    // https://developer.mozilla.org/en-US/docs/web/api/document/execcommand#browser_compatibility
    document.execCommand('copy');
    document.body.removeChild(fakeInput);

    onSuccess?.(text);
}

export function copyToClipboard(text = '', onSuccess?: CopySuccessFn, onFail?: CopyFailFn): void {
    if (!navigator.clipboard) {
        // https://caniuse.com/?search=navigator.clipboard
        copyToClipboardFallback(text, onSuccess);
        return;
    }

    navigator.clipboard
        .writeText(text)
        .then(
            () => onSuccess?.(text),
            () => onFail?.(text),
        )
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Error copying text to clipboard', error);
        });
}
